'use strict'

var zeroFill = require('zero-fill')
var parseIntStrict = require('parse-int')

var pad = zeroFill(2)

module.exports = function expandYear (year, now) {
  now = now || new Date()
  var base = now.getFullYear().toString().substr(0, 2)
  year = parseIntStrict(year)
  return parseIntStrict(base + pad(year))
}



//////////////////
// WEBPACK FOOTER
// ./~/expand-year/index.js
// module id = 863
// module chunks = 1